import { HeaderRouteType } from 'ui/pageHeader/PageHeader/fn/types'
import AppUrls from 'parts/constants/pageUrl'

export const routesEnd: HeaderRouteType[] = [
	{
		path: AppUrls.MySchools().url,
		breadcrumbName: AppUrls.MySchools().name,
	},
]
